module.exports = __webpack_public_path__ + "media/images/netball-152a6df0aa8d42f29517cea636c04155.svg";